var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
export class InogeniCam230 {
    constructor(log) {
        this.videoInput = 4; // test pattern as default
        this.sourceNames = ['usb1', 'usb2', 'hdmi', 'testpattern'];
        this.asyncHandlers = [
            {
                name: 'status',
                path: /\/api\/v1\/status/i,
                method: 'get',
                callback: (match, req) => __awaiter(this, void 0, void 0, function* () {
                    const response = {
                        firmwareVersion: '2.1',
                        boardRevision: 2,
                        temperature: 47,
                        networkEth0: {
                            mode: 'dhcp',
                            mac: 'D8:3A:DD:0E:84:DB',
                            ip: '192.168.100.188',
                            netmask: '255.255.255.0',
                            gateway: '192.168.100.254',
                        },
                        hdmiOutput: '1080p60',
                        usbOutput: '1080p30',
                        videoInputSwitchMode: 'manual',
                        videoInputs: Array.from({ length: 4 }, (v, i) => {
                            return {
                                name: `Input ${i + 1}`,
                                port: this.sourceNames[i].toUpperCase(),
                                isSelected: i === this.videoInput - 1,
                                selectedFormat: '1920x1080 30.00fps YUYV',
                                index: i,
                            };
                        }),
                        audioInputSwitchMode: 'follow video input',
                        audioInputs: [],
                    };
                    return this.makeResponse(req, JSON.stringify(response));
                }),
            },
            {
                name: 'matrixSwitch',
                path: /\/api\/v1\/setVideoInput\?input=(\d+)/i,
                method: 'post',
                callback: (match, req) => __awaiter(this, void 0, void 0, function* () {
                    this.videoInput = parseInt(match[1], 10);
                    const response = {
                        message: 'success',
                    };
                    return this.makeResponse(req, JSON.stringify(response));
                }),
            },
        ];
    }
    makeResponse(request, result) {
        return {
            status: 200,
            headers: {
                'okhttp-response-source': 'NETWORK 200',
                'keep-alive': 'timeout=60',
                'content-length': `'${result.length}'`,
                'cache-control': 'no-store',
                'okhttp-selected-protocol': 'http/1.1',
                'content-type': 'application/json',
                charset: 'utf-8',
            },
            data: result,
        };
    }
}
InogeniCam230.emulatorType = 'httpRequestEmulator';
InogeniCam230.key = '-NwVDmsic-i9xVvxQPcm';
